import { render, staticRenderFns } from "./InternetMessage.vue?vue&type=template&id=45ecc356"
import script from "./InternetMessage.vue?vue&type=script&lang=js"
export * from "./InternetMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports